
import people from "./people";

export default [
    {  
    name: "Sample Team 1",
    members:  [...people],
    addedToTournament: false
    },
    {  
      name: "Sample Team 2",
      members:  [...people],
      addedToTournament: false
    },
    {  
      name: "Sample Team 3",
      members:  [...people],
      addedToTournament: false
    },
    {  
      name: "Sample Team 4",
      members:  [...people],
      addedToTournament: false
    },
    {  
      name: "Sample Team 5",
      members:  [...people],
      addedToTournament: false
    },
    {  
      name: "Sample Team 6",
      members:  [...people],
      addedToTournament: false
    },
    {
      name: "Sample Team 7",
      members:  [...people],
      addedToTournament: false
    },
    {
      name: "Sample Team 8",
      members:  [...people],
      addedToTournament: false
    },
  ];
  